<template>
    <div class="leftBox" v-loading='uinfo_load'>
		<div class="ulogoBox">
			<el-image :src="ulogo">
				<div slot="error" class="image-slot">
					<el-image :src="defaUlogo"></el-image>
				</div>
			</el-image>
		</div>
		<div class="uinfo">
			<div class="uname">
				<h2>{{uname}}</h2>
				<!-- <p class="school">{{school}}</p> -->
				<p class="zy">{{zhuanye}}<span v-if="zhiyeCon">（{{cengci}}）</span></p>
			</div>
			<div class="ustudy">
				<h2>学习进度</h2>
				<div class="courseSt pr">
					<!-- text-color="#000" -->
					<el-progress :percentage="(done_study_hour/all_study_hour)*100"  style="margin-top: 10px;" :format="format" :text-inside="true" :stroke-width="15">
					</el-progress>
					<span class="all_study_hour">{{all_study_hour}}学时</span>
					<!-- <div class="cou zong"><p>总课程数</p><h3><font>{{mould_course_count}}</font>门</h3></div> -->
					<!-- <div class="cou guo" v-if="hideType === 3"><p>已通过课程数</p><h3><font>{{course_progress}}</font>门</h3></div> -->
				</div>
			</div>
			<div class="switchCourse" v-if="courseSwShow" @click="courseSwClick">
				切换课程<i class="iconfont">&#xe68c;</i>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'leftBox'
	,data () {
		return {
            uinfo_load:true,
            ulogo:'',
            defaUlogo:'',
            uname:'',
            school:'',
            zhuanye:'',
            zhiyeCon:'',
            cengci:'',
            mould_course_count:'',
            course_progress:'',
			done_study_hour:0,
			all_study_hour:10,
			courseSwShow:true
		}
	}
	,mounted:function(){
		//获取用户数据
        let that = this
        this.$selfjs.getUserCallFn(this, function(res){
			// console.log(res);
            let resData = res
            that.uinfo_load=false
			that.done_study_hour = resData.done_study_hour        	//学习时长
			that.all_study_hour = resData.all_study_hour        	//需要学习时长
			that.ulogo=resData.avatar						//用户头像
			that.uname=resData.nick_name					//用户名
			that.school=resData.school.school_name			//学校名称
			that.zhuanye=resData.major.major_name			//专业名称
			that.cengci=that.$selfjs.type_change(resData.major.major_level)		//层级
			that.mould_course_count=resData.mould_course_count			//课程总数
			that.course_progress=resData.course_progress				//课程进度
            that.defaUlogo = that.global.oss_website+'/pc/images/ulogo.jpg';
		})
	}
	,watch:{
	}
	,computed:{
        //根据身份隐藏内容
		hideType(){
			let hideType = parseInt(this.$store.state.hideType)
			this.zhiyeCon = (hideType === 9 || hideType === 10) ? false : true
			return hideType
		},
		
	}
	,methods:{
		format(percentage) {
      		return this.done_study_hour?this.done_study_hour+'学时':'';
      	},
		//切换课程点击
		courseSwClick(){
			//记录布局
			this.$store.commit("change_vuex",{
				key:"layout",
				value:1
			})
			this.jumpFn(['/web/range/', 'range'])
		},
		jumpFn:function(args){
			// console.log(args);
			this.$router.push({
				path: args[0],
				name: args[1],
				query: args[2],
				params: args[3]
			})
		}
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
.pr{
	position: relative;
}
.all_study_hour{
	position: absolute;
	width: 70px;
    right: -80px;
    top: 9px;
	color: #2991e1;
	font-weight: 700;
}
.leftBox .uinfo .ustudy{
	overflow: visible;
}
/* .el-progress-bar__innerText{
	color: red;
} */
</style>


// WEBPACK FOOTER //
// src/components/leftBox.vue